import { css } from 'styled-components';

/**
 * Card surfaces (modern-sea look): structure comes from lines, not shadows.
 * A thin border with a 2px dark top rule and square corners.
 */
export const panel = css`
  border: 1px solid ${(p) => p.theme.colors.border.main};
  border-top: 2px solid ${(p) => p.theme.colors.general.black};
  border-radius: 0;
  box-shadow: none;
`;

/** Form fields: square, a 3:1 border and a 2px focus ring in the link colour. */
export const field = css`
  border: 1px solid ${(p) => p.theme.colors.grey[50]};
  border-radius: 0;
  box-shadow: none;
  background-color: ${(p) => p.theme.colors.general.white};
  color: ${(p) => p.theme.colors.general.black};

  &:focus {
    outline: 2px solid ${(p) => p.theme.colors.general.link};
    outline-offset: -1px;
  }

  &::placeholder {
    color: ${(p) => p.theme.colors.general.placeholder};
  }
`;
